module.exports = __webpack_public_path__ + "img/Nastavení.93cc4759.svg";